import Cookie from "js-cookie" // undocumented cookies
import * as MODALS from "@kiwicom/nitro/lib/consts/modals"
import type { Modal } from "@kiwicom/nitro/lib/consts/modals"

const SIDENAV_OPENED_CLASS = "sidenav-opened"
const RECENT_SEARCH_REDIRECT_COOKIE = "recentRedirect"
const MOBILE_FIXED = "_mobile-fixed"

export const modals = (modal: Modal) => {
  const body = document.querySelector("body")
  const mainView = document.querySelector(".MainView")

  if (body) {
    if (modal === MODALS.SIDE_NAV) {
      body.classList.add(SIDENAV_OPENED_CLASS)
    } else {
      body.classList.remove(SIDENAV_OPENED_CLASS)
    }
  }

  if (mainView) {
    if (modal === MODALS.SIGN_IN || modal === MODALS.REGISTER || modal === MODALS.MY_BOOKING) {
      mainView.classList.add(MOBILE_FIXED)
    } else {
      mainView.classList.remove(MOBILE_FIXED)
    }
  }
}

export const logoClick = () => {
  Cookie.remove(RECENT_SEARCH_REDIRECT_COOKIE)
}
